import { Component } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'dc-lesson-form',
  templateUrl: './lesson-form.component.html',
  styleUrls: ['./lesson-form.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule],
})
export class DCLessonFormComponent {
  // Form implementation will go here
}
